import { apiFetch } from './api';

export function getReglesRappel(params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== '')
  ).toString();

  return apiFetch(`/regles-rappel${query ? `?${query}` : ''}`);
}

export function createRegleRappel(data) {
  return apiFetch('/regles-rappel', { method: 'POST', body: JSON.stringify(data) });
}

export function updateRegleRappel(id, data) {
  return apiFetch(`/regles-rappel/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export function deleteRegleRappel(id) {
  return apiFetch(`/regles-rappel/${id}`, { method: 'DELETE' });
}
